<div class="q-hero">
  <h1>11plus Exam Question Bank</h1>

  <button>View All</button>
</div>

<div class="question-bank"
*ngFor="let subject of subjects; let i index">
  <h2>{{subject.subjectName}}</h2>

  <div class="qb-cards" 
  *ngFor="let pack of subject.packs; let i = index">

    <div class="qb-card {{pack.class}}">
      <img src="{{pack.packImg}}" alt="" />

      <p class="qbc-head">{{pack.packName}}</p>

      <p class="qbc-des"> <Strong>{{pack.totalQuestions}}</Strong> {{pack.packDes}}</p>

      <a class="view-btn" href='{{pack.qbLink}}'>View</a>
    </div>

  </div>
  
</div>
